export default {
  autoResetIntervalSeconds: 10 * 60 * 60,
}
